import { createAsyncAction } from 'typesafe-actions';
import * as types from './siteHierarchy.actionTypes';
import { SiteHierarchyCompact } from './type';

export const fetchSiteHierarchy = createAsyncAction(
	types.FETCH_SITE_HIERARCHY_REQUEST,
	types.FETCH_SITE_HIERARCHY_SUCCESS,
	types.FETCH_SITE_HIERARCHY_FAILED,
)<{ withDepartmentAccess?: boolean }, { siteHierarchy: SiteHierarchyCompact[] }, { error: string }>();
